import React from 'react';

import PropTypes from 'prop-types';

import { DropdownMenu } from 'wanderu-components';
import FlagIcon from 'wanderu-flag-icons';
import { localize } from 'wanderu-i18n';

import MultiColumnLocaleMenu from './MultiColumnLocaleMenu/MultiColumnLocaleMenu';
import VerticalLocaleMenu from './VerticalLocaleMenu/VerticalLocaleMenu';
import countryConfig from './config';
import Events from './events/LocaleEvents';

import styles from './LocaleMenu.scss';

function LocaleMenu(props) {
    const {
        currentLocale,
        onLocaleChange = () => undefined,
        path,
        supportedLocales,
        vertical,
    } = props;

    const countryLocaleConfigs = countryConfig
        .getCountryLocaleConfigs(supportedLocales, currentLocale);
    const _currentCountryConfig = countryLocaleConfigs.find((config) => config.isActive);

    const onMenuClick = (navType) => (isOpen) => {
        if (!isOpen) {
            Events.clicked({
                action: 'expand_menu',
                navType,
                selectedCountry: currentLocale,
            });
        }
    };

    const onItemSelect = (navType) => (selectedCountry) => {
        onLocaleChange(selectedCountry);
        Events.clicked({
            action: 'select',
            navType,
            selectedCountry,
            unselectedCountry: currentLocale,
        });
    };

    return (
        <div className={styles.container}>
            {vertical && (
                <VerticalLocaleMenu
                    countryLocaleConfigs={countryLocaleConfigs}
                    currentLocale={currentLocale}
                    onItemClick={onItemSelect('hamburger')}
                    onToggleMenu={onMenuClick('hamburger')}
                    path={path}
                />
            )}
            {!vertical && (
                <DropdownMenu
                    altText={`${_currentCountryConfig.countryName} flag`}
                    onToggleMenu={onMenuClick('nav_bar')}
                    title={<FlagIcon
                        alt={`${_currentCountryConfig.countryName} flag`}
                        className={styles.localeFlag}
                        code={_currentCountryConfig.countryCode}
                    />}
                    alwaysRendered
                >
                    <MultiColumnLocaleMenu
                        columns={3}
                        countryLocaleConfigs={countryLocaleConfigs}
                        onItemClick={onItemSelect('nav_bar')}
                        path={path}
                    />
                </DropdownMenu>
            )}
        </div>
    );
}

LocaleMenu.propTypes = {
    currentLocale: PropTypes.string.isRequired,
    onLocaleChange: PropTypes.func,
    path: PropTypes.string.isRequired,
    supportedLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
    vertical: PropTypes.bool,
};

export { LocaleMenu };
export default localize(LocaleMenu, ['t'], 'baseApp');
